import gql from 'graphql-tag';

export const formElementFragment = gql`
  fragment FormElement_element on FormElement {
    type
    id
    path
    name
    value
    placeholder
    validation {
      isRequired
      maxLength
      minLength
    }
  }
`;

export const GET_CASE_DATA_FORM = gql`
  query ($appointmentId: String!) {
    getCaseDataForm( appointmentId: $appointmentId ) {
      form {
        ...FormElement_element
        elements {
          ...FormElement_element
        }
      }
    }
  }
  ${ formElementFragment }
`;
